/* eslint-disable no-unused-expressions */
<template>
  <v-container fluid>
    <v-container
      v-if="inventoryTag != null"
      style="font-size: 1.3em !important;"
      fluid
    >
      <v-row
        v-if="physicalCountList"
      >
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card outlined class="rounded-lg">
            <v-card-text class="d-flex align-center pa-4">
              <v-icon color="primary" class="mr-3">
                mdi-clipboard-list-outline
              </v-icon>
              <div class="d-flex flex-wrap align-center flex-grow-1 text-break">
                <div class="text-body-2 grey--text text--darken-1 mr-3">
                  Active Physical Count:
                </div>
                <div class="text-subtitle-1 font-weight-bold text--primary mr-3">
                  {{ physicalCountList.name }}
                </div>
                <div class="text-body-2 grey--text text--darken-1">
                  As of {{ new Date(`${physicalCountList.date} 00:00`).toDateString().substring(4) }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="3">
          <v-card outlined class="rounded-lg">
            <v-card-text class="pa-5">
              <div class="text-subtitle-2 text-uppercase grey--text text--darken-1 mb-1 text-center">
                QR Code
              </div>
              <div class="text-h4 font-weight-bold text--primary mb-3 text-center">
                {{ qrCode }}
              </div>
              <div class="text-center">
                <v-chip
                  class="px-4 py-2 font-weight-bold inventory-identification-class"
                  text-color="white"
                  :color="inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.color : 'white'"
                >
                  {{ inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.name : '-' }}
                </v-chip>
              </div>
              <v-divider class="my-4" />
              <v-img
                v-if="inventoryTag.item && inventoryTag.item.photo && inventoryTag.item.mime_type"
                :src="convertedPhoto(inventoryTag.item.photo, inventoryTag.item.mime_type)"
                contain
                max-height="240"
                class="mx-auto my-4"
              />
              <v-sheet
                v-else
                height="240"
                color="grey lighten-4"
                class="rounded d-flex flex-column align-center justify-center my-4"
              >
                <v-icon large color="grey">
                  mdi-image-outline
                </v-icon>
                <span class="text-caption grey--text text--darken-1 mt-2">
                  No Item Image
                </span>
              </v-sheet>
              <div
                v-if="inventoryTag.item && inventoryTag.item.photo && inventoryTag.item.mime_type"
                class="text-caption grey--text text--darken-1"
              >
                Item Image
              </div>
              <v-divider class="my-4" />
              <div class="text-subtitle-2 grey--text text--darken-2 mb-3">
                Supplier Label
              </div>
              <v-sheet
                min-height="116"
                color="grey lighten-4"
                class="rounded d-flex flex-column align-center justify-center pa-3"
              >
                <a
                  v-if="inventoryTag.supplier_label && inventoryTag.supplier_label_mime_type"
                  class="d-block"
                  style="width: 100%;"
                  @click="openItemShowImageForm(inventoryTag.supplier_label, inventoryTag.supplier_label_mime_type)"
                >
                  <v-img
                    :src="convertedPhoto(inventoryTag.supplier_label, inventoryTag.supplier_label_mime_type)"
                    contain
                    width="100%"
                  />
                </a>
                <template v-else>
                  <v-icon color="grey">
                    mdi-label-outline
                  </v-icon>
                  <span class="text-caption grey--text text--darken-1 mt-2">
                    No Supplier Label
                  </span>
                </template>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-form ref="editForm">
            <v-card outlined>
              <v-card-title>
                <span class="text-h4 font-weight-bold">
                  Inventory Tag Details
                </span>
                <v-spacer />
                <v-btn
                  v-if="physicalCountList && !isEdit"
                  color="primary"
                  class="mr-2 mb-2"
                  outlined
                  x-large
                  @click="toggleEdit"
                >
                  edit
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <!-- <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Class
                    </h5>
                    <inventory-class-select-element
                      v-model="inventoryClassId"
                      :is-add-all="false"
                      :outlined="true"
                      :is-label="false"
                      :readonly="true"
                    />
                  </v-col> -->
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Inventory Item
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.inventory_item_id"
                      :items="inventoryItems"
                      outlined
                      :readonly="true"
                      :style="'pointer-events: none'"
                      append-icon=""
                      :item-text="
                        (item) => item.material_id + ': ' + item.name
                      "
                      item-value="id"
                      :rules="[(v) => !!v || 'Inventory Item is required']"
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1 mr-3"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item && item.classes ? item.classes.color : 'white'"
                        >
                          {{ item && item.classes ? item.classes.name : '' }}
                        </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1 mr-3"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item && item.classes ? item.classes.color : 'white'"
                        >
                          {{ item && item.classes ? item.classes.name : '' }}
                        </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col
                    v-if="inventoryTag && inventoryTag.item && (inventoryTag.item.classes.id !== inventoryClassIdGlass && inventoryTag.item.classes.id !== inventoryClassIdVWDGlass && inventoryTag.item.classes.id !== inventoryClassIdPanels && inventoryTag.item.classes.id !== inventoryClassIdSID && inventoryTag.item.classes.id != inventoryClassIdInst && inventoryTag.item.classes.id != inventoryClassIdParts && inventoryTag.item.classes.id != inventoryClassIdPaint && inventoryTag.item.classes.id != inventoryClassIdPatioDoor && inventoryTag.item.classes.id != inventoryClassIdEquipment)"
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Length<RedAsterisk v-if="isEdit && !qrCodeIsUpc" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.length_id"
                      :items="lengthsList"
                      append-icon=""
                      :readonly="isEdit ? false : true"
                      :style="isEdit ? '' : 'pointer-events: none'"
                      outlined
                      item-text="name"
                      item-value="id"
                      :rules="qrCodeIsUpc ? [] : [(v) => !!v || 'Length is required']"
                      :loading="loadingLength"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      UOM<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.uom_id"
                      :items="uomsList"
                      :readonly="isEdit ? false : true"
                      item-text="name"
                      item-value="id"
                      :style="isEdit ? '' : 'pointer-events: none'"
                      append-icon=""
                      outlined
                      :loading="loadingUom"
                      :rules="[(v) => !!v || 'UOM is required']"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                    cols="12"
                    sm="6"
                    md="4"
                    class="text-center pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Door Height<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-text-field
                      v-model="inventoryTag.height"
                      outlined
                      :readonly="isEdit ? false : true"
                      :rules="[(v) => !!v || 'Door height is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                    cols="12"
                    sm="6"
                    md="4"
                    class="text-center pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Door Width<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-text-field
                      v-model="inventoryTag.width"
                      outlined
                      :readonly="isEdit ? false : true"
                      :rules="[(v) => !!v || 'Door width is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                    cols="12"
                    sm="12"
                    md="12"
                    class="pt-0 pr-1 pl-1 pb-0"
                    style=""
                  >
                    <h5 class="h5">
                      Interior Color<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.color_id"
                      :items="colorsList"
                      item-text="code"
                      append-icon=""
                      item-value="id"
                      :readonly="isEdit ? false : true"
                      outlined
                      :rules="[(v) => !!v || 'Interior Color is required']"
                    >
                      <template #selection="{ item }">
                        <span>
                          {{ item.code }}
                        </span>
                      </template>
                      <template #item="{ item }">
                        <span>
                          {{ item.code }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes.id === inventoryClassIdPatioDoor"
                    cols="12"
                    sm="12"
                    md="12"
                    class="pt-0 pr-1 pl-1 pb-0"
                    style=""
                  >
                    <h5 class="h5">
                      Exterior Color<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.ex_color_id"
                      :items="colorsList"
                      item-text="code"
                      append-icon=""
                      item-value="id"
                      :readonly="isEdit ? false : true"
                      outlined
                      :rules="[(v) => !!v || 'Exterior Color is required']"
                    >
                      <template #selection="{ item }">
                        <span>
                          {{ item.code }}
                        </span>
                      </template>
                      <template #item="{ item }">
                        <span>
                          {{ item.code }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Location<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.location_id"
                      :items="locationsList"
                      :readonly="isEdit ? false : true"
                      item-text="name"
                      item-value="id"
                      append-icon=""
                      :style="isEdit ? '' : 'pointer-events: none'"
                      outlined
                      :rules="[(v) => !!v || 'Location is required']"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Shelf<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.inventory_location_id"
                      :items="inventoryLocations"
                      :readonly="isEdit ? false : true"
                      item-text="name"
                      item-value="id"
                      :style="isEdit ? '' : 'pointer-events: none'"
                      append-icon=""
                      outlined
                      :rules="[(v) => !!v || 'Inv. Location is required']"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      PO#
                    </h5>
                    <v-text-field
                      v-model="inventoryTag.po_number"
                      outlined
                      :readonly="isEdit ? false : true"
                      :style="isEdit ? '' : 'pointer-events: none'"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryClassId === inventoryClassIdSID"
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Size<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.door_size_id"
                      :items="doorSizes"
                      item-text="name"
                      :readonly="isEdit ? false : true"
                      append-icon=""
                      item-value="id"
                      outlined
                      :rules="[(v) => !!v || 'Size is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryClassId === inventoryClassIdSID && (inventoryTag.inventory_item_id === inventoryIdSlab || inventoryTag.inventory_item_id === inventoryIdInsertF)"
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Hinge<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.door_hinge_id"
                      :items="doorHinges"
                      item-text="name"
                      :readonly="isEdit ? false : true"
                      append-icon=""
                      item-value="id"
                      outlined
                      :rules="[(v) => !!v || 'Hinge is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryClassId === inventoryClassIdSID && (inventoryTag.inventory_item_id === inventoryIdSlab || inventoryTag.inventory_item_id === inventoryIdInsertF)"
                    cols="12"
                    sm="6"
                    md="4"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Swing
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.door_swing_id"
                      :items="doorSwings"
                      item-text="name"
                      append-icon=""
                      item-value="id"
                      :readonly="isEdit ? false : true"
                      outlined
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryClassId === inventoryClassIdSID && inventoryTag.inventory_item_id === inventoryIdInsert"
                    cols="12"
                    sm="6"
                    md="4"

                    class="pt-0 pr-1 pl-1"
                  >
                    <h5 class="h5">
                      Lite<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.door_lite_id"
                      :items="doorLites"
                      item-text="name"
                      append-icon=""
                      item-value="id"
                      :readonly="isEdit ? false : true"
                      outlined
                      :rules="[(v) => !!v || 'Lite is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                    cols="12"
                    sm="6"
                    md="4"
                    class="text-center pr-1 pl-1"
                  >
                    <h5 class="h5">
                      Ven. Batch#<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-text-field
                      v-model="inventoryTag.batch_number"
                      outlined
                      :readonly="isEdit ? false : true"
                      :rules="[(v) => !!v || 'Vendor Batch# is required']"
                    />
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                    cols="12"
                    sm="6"
                    md="4"
                    class="text-center pr-1 pl-1"
                  >
                    <h5 class="h5">
                      Prod. Date<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-menu
                      ref="menu"
                      v-model="dateMenu"
                      :return-value.sync="inventoryTag.production_date"
                      transition="scale-transition"
                      offset-y
                      left
                      :disabled="isEdit ? false : true"
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="inventoryTag.production_date"
                          outlined
                          :readonly="isEdit ? false : true"
                          v-bind="attrs"
                          :rules="[(v) => !!v || ' Production Date is required']"
                          v-on="on"
                          @change="$refs.menu.save(inventoryTag.production_date)"
                        />
                      </template>
                      <v-date-picker
                        v-model="inventoryTag.production_date"
                        no-title
                        scrollable
                        :readonly="isEdit ? false : true"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="inventoryTag.production_date = null"
                        >
                          Clear
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    v-if="inventoryTag && inventoryTag.item && (inventoryTag.item.classes.id !== inventoryClassIdGlass && inventoryTag.item.classes.id !== inventoryClassIdVWDGlass && inventoryTag.item.classes.id !== inventoryClassIdSID && inventoryTag.item.classes.id != inventoryClassIdInst && inventoryTag.item.classes.id != inventoryClassIdParts && inventoryTag.item.classes.id != inventoryClassIdPaint && inventoryTag.item.classes.id != inventoryClassIdPatioDoor && inventoryTag.item.classes.id != inventoryClassIdEquipment)"
                    cols="12"
                    sm="12"
                    md="12"

                    class="pr-1 pl-1 pt-0 pb-0"
                  >
                    <h5 class="h5">
                      Colour<RedAsterisk v-if="isEdit" />
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.color_id"
                      :items="colorsList"
                      :readonly="isEdit ? false : true"
                      :item-text="
                        (item) => item.code + (item.name ? ': ' + item.name : '')
                      "
                      item-value="id"
                      :style="isEdit ? '' : 'pointer-events: none'"
                      append-icon=""
                      outlined
                      :rules="isColorRequiredForCurrentClass ? [] :[(v) => !!v || 'Colour is required']"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-1" />
                </v-row>
                <v-row
                  v-if="inventoryClassId === inventoryClassIdPatioDoor"
                >
                  <v-col
                    class="pt-0 pr-6"
                    cols="auto"
                  >
                    <v-radio-group
                      v-model="inventoryTag.door_screen_id"
                      hide-details
                      class="mt-0"
                      :readonly="isEdit ? false : true"
                    >
                      <template #label>
                        <span style="font-size: 17.264px; color: #000; font-weight: bold;">Screen<RedAsterisk v-if="isEdit" /></span>
                      </template>
                      <v-row>
                        <v-col cols="auto">
                          <v-radio
                            label="WITH SCREEN"
                            :value="1"
                          />
                        </v-col>
                        <v-col cols="auto">
                          <v-radio
                            label="WITHOUT SCREEN"
                            :value="2"
                          />
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <v-col
                    class="pt-0 pr-6"
                    cols="auto"
                  >
                    <v-radio-group
                      v-model="inventoryTag.is_fritted"
                      hide-details
                      class="mt-0"
                      :readonly="isEdit ? false : true"
                    >
                      <template #label>
                        <span style="font-size: 17.264px; color: #000; font-weight: bold;">Fritted<RedAsterisk v-if="isEdit" /></span>
                      </template>
                      <v-row>
                        <v-col cols="auto">
                          <v-radio
                            label="FRITTED"
                            :value="1"
                          />
                        </v-col>
                        <v-col cols="auto">
                          <v-radio
                            label="NON-FRITTED"
                            :value="0"
                          />
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="inventoryClassId === inventoryClassIdPanels">
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    class="pt-0 pr-1 pl-1 pb-0"
                  >
                    <h5 class="h5">
                      Dimension Unit
                    </h5>
                    <v-autocomplete
                      v-model="inventoryTag.dimension_unit_id"
                      :items="dimensionUnits"
                      readonly
                      item-text="name"
                      item-value="id"
                      append-icon=""
                      outlined
                      persistant-hint
                      hint="Dimension Unit is read only"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="inventoryClassId === inventoryClassIdSID"
                >
                  <v-col
                    class="pa-4 mb-2"
                    cols="11"
                    style="background-color: #E8F5E9; border: 2px solid rgba(0,0,0,0.2)"
                  >
                    <v-row>
                      <v-col
                        class="pt-0 pr-6"
                        cols="auto"
                      >
                        <v-radio-group
                          v-model="inventoryTag.is_painted"
                          hide-details
                          class="mt-0"
                          :readonly="isEdit ? false : true"
                        >
                          <template #label>
                            <span style="font-size: 17.264px; color: #000; font-weight: bold;">Paint<RedAsterisk v-if="isEdit" /></span>
                          </template>
                          <v-row>
                            <v-col cols="auto">
                              <v-radio
                                label="PAINTED"
                                :value="1"
                              />
                            </v-col>
                            <v-col cols="auto">
                              <v-radio
                                label="NON-PAINTED"
                                :value="0"
                              />
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                      <v-col
                        v-if="inventoryTag.is_painted == 1"
                        cols="12"
                        sm="12"
                        md="12"
                        class="pt-0 pr-1 pl-1 pb-0"
                        style=""
                      >
                        <h5 class="h5">
                          {{ inventoryTag.inventory_item_id !== inventoryIdSweep ? 'Interior Color' : 'Color' }}<RedAsterisk v-if="isEdit" />
                        </h5>
                        <v-autocomplete
                          v-model="inventoryTag.color_id"
                          :items="colorsList"
                          item-text="code"
                          append-icon=""
                          item-value="id"
                          outlined
                          :readonly="isEdit ? false : true"
                          :rules="[(v) => !!v || `${inventoryTag.inventory_item_id !== inventoryIdSweep ? 'Interior Color' : 'Color'} is required`]"
                        >
                          <template #selection="{ item }">
                            <span>
                              {{ item.code }}
                            </span>
                          </template>
                          <template #item="{ item }">
                            <span>
                              {{ item.code }}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        v-if="inventoryTag.is_painted == 1 && inventoryTag.inventory_item_id !== inventoryIdSweep"
                        cols="12"
                        sm="12"
                        md="12"
                        class="pt-0 pr-1 pl-1 pb-0"
                        style=""
                      >
                        <h5 class="h5">
                          Exterior Color<RedAsterisk v-if="isEdit" />
                        </h5>
                        <v-autocomplete
                          v-model="inventoryTag.ex_color_id"
                          :items="colorsList"
                          item-text="code"
                          append-icon=""
                          item-value="id"
                          :readonly="isEdit ? false : true"
                          outlined
                          :rules="[(v) => !!v || 'Exterior Color is required']"
                        >
                          <template #selection="{ item }">
                            <span>
                              {{ item.code }}
                            </span>
                          </template>
                          <template #item="{ item }">
                            <span>
                              {{ item.code }}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
          <v-row v-if="isCounted" class="ma-0 mt-4">
            <v-col
              cols="12"
              class="pa-0"
            >
              <v-alert
                type="success"
                text
                class="rounded-lg mb-0"
              >
                <div class="d-flex flex-wrap align-center">
                  <div class="text-body-2 font-weight-bold mr-1">
                    Already counted with quantity: {{ inventoryTag.counted_quantity }}
                  </div>
                  <div
                    v-if="inventoryTag.counted_quantity != inventoryTag.quantity"
                    class="text-body-2 d-flex align-center flex-wrap mr-3"
                  >
                    Modified quantity: {{ inventoryTag.quantity }}
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          small
                          color="success"
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        Quantity after adjustments have been made from STL QR, RM Receiving QR, and Moving QR
                      </span>
                    </v-tooltip>
                  </div>
                  <div class="text-body-2">
                    on {{ new Date(inventoryTag.updated_at ? inventoryTag.updated_at.replace(' ', 'T') : inventoryTag.created_at.replace(' ', 'T')).toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }) }}
                  </div>
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-card outlined class="mt-4">
            <v-card-title>Physical Count</v-card-title>
            <v-card-text>
                <v-row>
                  <v-col>
                    <span v-if="isCounted">Enter recounted quantity<RedAsterisk /></span>
                    <span v-else>Enter counted quantity<RedAsterisk /></span>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col
                    class="pt-0"
                    cols="12"
                    sm="6"
                  >
                    <v-form ref="form">
                      <v-text-field
                        v-model="quantity"
                        :rules="[(v) => !!v || 'Quantity is required', inventoryClassId === inventoryClassIdPaint ? rules.wholeAndHalfNumber : rules.wholeNumber]"
                        required
                        outlined
                        type="number"
                        :step="inventoryClassId === inventoryClassIdPaint ? '0.5' : '1'"
                        min="0"
                      />
                    </v-form>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="d-flex flex-wrap align-start pt-0"
                  >
                    <v-btn
                      color="primary"
                      x-large
                      class="mr-2 mb-2"
                      :disabled="isSubmitting"
                      :loading="isSubmitting"
                      @click="submit"
                    >
                      submit
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mr-2 mb-2"
                      outlined
                      x-large
                      @click="cancel"
                    >
                      cancel
                    </v-btn>
                  </v-col>
                </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined class="mt-4">
            <v-card-text class="d-flex flex-wrap">
              <template v-if="physicalCountList">
                <v-btn
                  color="orange"
                  class="mr-2 mb-2"
                  outlined
                  x-large
                  @click="openNotes"
                >
                  Notes
                </v-btn>
                <v-btn
                  color="primary"
                  class="mr-2 mb-2"
                  x-large
                  @click="historyRedirect"
                >
                  History
                </v-btn>
              </template>
              <v-btn
                v-if="isPhysicalCountActivated && isCounted && qrCodeIsUpc"
                class="mr-2 mb-2"
                color="teal"
                x-large
                outlined
                @click="receive"
              >
                RECEIVE
              </v-btn>

              <v-btn
                v-if="isPhysicalCountActivated && isCounted && !qrCodeIsUpc"
                class="mr-2 mb-2"
                color="warning"
                x-large
                outlined
                @click="move"
              >
                MOVE
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <h2 v-if="isActivatedVisible">
      <v-row>
        <v-col class="text-center">
          <v-row>
            <v-col>
              {{ topErrorMessage }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                class="mr-4"
                outlined
                x-large
                @click="redirectBack"
              >
                scan new qr code
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </h2>
    <InventoryItemShowImageForm
      ref="itemShowImageForm"
    />
    <inventory-tag-note-form
      ref="noteForm"
    />
    <inventory-qr-form
      ref="tagForm"
      @success="receiveSuccess"
    />
    <inventory-upc-form
      ref="upcForm"
      @success="receiveSuccess"
    />
  </v-container>
</template>

<script>
import InventoryItemShowImageForm from '@/components/forms/InventoryItemShowImageForm';
import PhysicalCountApi from '@/api/PhysicalCountApi';
import InventoryTagNoteForm from '@/components/forms/inventoryTags/InventoryTagNoteForm';
import InventoryQrForm from '@/components/forms/inventoryQrs/InventoryQrForm.vue';
import InventoryUpcForm from '@/components/forms/inventoryQrs/InventoryUpcForm.vue';
import * as ValidationHelpers from '@/helpers/ValidationHelpers';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    InventoryItemShowImageForm,
    InventoryTagNoteForm,
    InventoryQrForm,
    InventoryUpcForm
  },
  data: () => ({
    qrCode: '',
    inventoryTag: null,
    lengthsList: [],
    uomsList: [],
    colorsList: [],
    inventoryItems: [],
    inventoryLocations: [],
    locationsList: [],
    isActivatedVisible: false,
    quantity: null,
    physicalCount: null,
    isCounted: false,
    isEdit: false,
    photo: null,
    mime_type: null,
    inventoryClasses: '',
    dateMenu: false,

    inventoryClassId: null,
    inventoryClassIdGlass: 5,
    inventoryClassIdVWDGlass: 7,
    inventoryClassIdPanels: 8,
    inventoryClassIdSID: 9,
    inventoryClassIdInst: 4,
    inventoryClassIdParts: 11,
    inventoryClassIdPaint: 12,
    inventoryClassIdEquipment: 13,
    inventoryClassIdPatioDoor: 14,
    inventoryClassIdEuroDoor: 15,
    inventoryIdSlab: 1100,
    inventoryIdSweep: 1101,
    inventoryIdInsert: 1102,
    inventoryIdInsertF: 4058,
    glassCodeTypeIdSealedUnit: 2,
    
    doorHinges: [],
    doorSwings: [],
    doorLites: [],
    doorSizes: [],
    dimensionUnits: [],

    topErrorMessage: 'THIS QR CODE DOES NOT SATISFY THE REQUIREMENTS OF THE ACTIVE PHYSICAL COUNT',
    loadingLength: false,
    loadingUom: false,
    isSubmitting: false,

    rules: {
      wholeNumber: (v) => /^\d+$/.test(v) || 'Please enter a whole number',
      wholeAndHalfNumber: (v) => /^(0?(\.5)?|[1-9]\d*(\.0|\.5)?)$/.test(v) || 'Enter a whole number or a number ending in .5'
    }
  }),
  computed: {
    ...mapGetters([
      'isPhysicalCountActivated',
      'currentPhysicalCount',
    ]),
    ...mapState({
      user: 'user',
      invClasses: 'invClasses',
    }),

    isClassIncludedInPhysicalCount() {
      if (!this.currentPhysicalCount) return true;
      const inventoryClassId = this.inventoryTag ? this.inventoryTag.inventory_class_id : null;
      return this.currentPhysicalCount.classes.some((c) => c.id === inventoryClassId);
    },

    qrCodeIsUpc() {
      return parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999;
    },

    isColorRequiredForCurrentClass() {
      if (!this.inventoryTag || !this.inventoryTag.item) return false;
      const classId = this.inventoryTag.item.inventory_class_id;
      const classesRequiringColor = [
        this.inventoryClassIdEuroDoor
      ];
      return classesRequiringColor.includes(classId);
    }
  },
  watch: {
    inventoryTag(value) {
      if (!value) return;
      if (value.item.class_names) {
        this.inventoryClasses = value.item.class_names;
      }
    },
    inventoryClassId() {
      this.getInventoryItems();
    },
    // eslint-disable-next-line func-names
    'inventoryTag.inventory_item_id': function (val) {
      if (val === this.inventoryIdSlab || val === this.inventoryIdSweep || val === this.inventoryIdInsert) {
        this.getDoorSizes();
      }

      if (val === this.inventoryIdSlab) {
        this.inventoryTag.door_lite_id = null;
      } else if (val === this.inventoryIdSweep) {
        this.inventoryTag.door_hinge_id = null;
        this.inventoryTag.door_swing_id = null;
        this.inventoryTag.door_lite_id = null;
        this.inventoryTag.ex_color_id = null;
      } else if (val === this.inventoryIdInsert) {
        this.inventoryTag.door_hinge_id = null;
        this.inventoryTag.door_swing_id = null;
      }

      this.getUoms();
      this.getLengths();
    },
    // eslint-disable-next-line func-names
    'inventoryTag.is_painted': function (val) {
      if (val === 0) {
        this.inventoryTag.color_id = null;
        this.inventoryTag.ex_color_id = null;
      }
    },
    // eslint-disable-next-line func-names
    'inventoryTag.location_id': function (value) {
      if (!value) return;
      this.getInventoryLocations();
    },
    // eslint-disable-next-line func-names
    'inventoryTag.production_date': function (val) {
      if (this.$refs.menu) { this.$refs.menu.save(val); }
    },
  },

  created() {
    this.qrCode = this.$route.params.code;
    this.init();
  },

  methods: {
    async init() {
      await this.getActivePhysicalCountList();
      this.getInventoryTag();
      this.getUoms();
      this.getColors();
      this.getLengths();
      this.getInventoryItems();
      this.getLocations();
      this.getInventoryLocations();
      this.getDoorHinges();
      this.getDoorSwings();
      this.getDoorLites();
      this.getDimensionUnits();
    },

    // QR CODE IS THE SAME AS INVENTORY TAG
    async getInventoryTag() {
      if (!this.qrCode) return;
      const submitModel = {
        filters: {
          inventory_tag: this.qrCode,
          class_ids: this.physicalCountList.classes.map((x) => x.id),
          is_qty_on_hand_o: 0,
        },
        includes: {
          is_include_item_image: true,
          is_include_supplier_label: true,
        },
      };

      const res = await this.$api.inventoryTag.read(submitModel);
      if (res && res.status === 505) {
        this.topErrorMessage = res.message;
        this.isActivatedVisible = true;
        return;
      }
      if (!res || !res.data || !res.data[0]) {
        this.isActivatedVisible = true;
        return;
      }
      const data = res.data[0];

      this.isActivatedVisible = false;
      this.inventoryTag = data;
      this.inventoryClassId = this.inventoryTag.item.inventory_class_id;
      this.photo = data.item && data.item.photo ? data.item.photo : null;
      this.mime_type = data.item && data.item.mime_type ? data.item.mime_type : null;
      this.getPhysicalCount();
    },

    async getPhysicalCount() {
      if (!this.inventoryTag) return;
      const response = await PhysicalCountApi.getByList(this.physicalCountList.id, this.inventoryTag.inventory_tag);
      if (!response) {
        return;
      }
      if (response.id) {
        this.isCounted = true;
        // if physical count with this tag exists
        this.inventoryTag = response;
      }
    },

    async getActivePhysicalCountList() {
      this.physicalCountList = await this.$api.physicalCountList.getActive();
    },

    async getColors() {
      const submitModel = {
        filters: {
        },
      };

      this.colorsList = await this.$api.color.read(submitModel);
    },

    async getLengths() {
      this.loadingLength = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryTag ? this.inventoryTag.inventory_item_id : null,
          inventory_class_id: this.inventoryClassId,
        },
      };
      this.lengthsList = await this.$api.length.read(submitData);
      this.loadingLength = false;
    },

    async getInventoryItems() {
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
        },
      };

      const res = await this.$api.inventoryItem.readData(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.inventoryItems = [];
        return;
      }
      this.inventoryItems = res.data;
    },

    async getInventoryLocations() {
      this.$nextTick(async () => {
        const locationId = this.inventoryTag && this.inventoryTag.location_id ? this.inventoryTag.location_id : 1;
        const readModel = {
          filters:
        {
          location_id: locationId,
        },
        };
        this.inventoryLocations = await this.$api.inventoryLocation.read(readModel);
      });
    },

    async getLocations() {
      this.locationsList = await this.$api.location.getList();
    },

    async getUoms() {
      this.loadingUom = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryTag ? this.inventoryTag.inventory_item_id : null,
        },
      };
      this.uomsList = await this.$api.uom.read(submitData);
      this.loadingUom = false;
    },

    async getDoorHinges() {
      this.doorHinges = await this.$api.doorHinge.getList();
    },

    async getDoorSwings() {
      this.doorSwings = await this.$api.doorSwing.getList();
    },

    async getDoorLites() {
      this.doorLites = await this.$api.doorLite.getList();
    },

    async getDoorSizes() {
      this.doorSizes = await this.$api.doorSize.get(`${this.inventoryTag.inventory_item_id}`);
    },

    async getDimensionUnits() {
      const uomCategoryIdArea = 2;
      const submitData = {
        filters: {
          uom_category_id: uomCategoryIdArea,
        },
      };
      this.dimensionUnits = await this.$api.uom.read(submitData);
    },

    async submit() {
      if (this.isSubmitting) return false;
      if (!this.physicalCountList && !this.inventoryTag) return;
      if (!await this.$refs.form.validate() || !await this.$refs.editForm.validate()) return;
      if (this.inventoryClassId === this.inventoryClassIdPatioDoor && (!this.isDecimalInFractions(this.inventoryTag.width) || !this.isDecimalInFractions(this.inventoryTag.height))) {
        this.$bus.$emit('showError', 'Incorrect Width or Height value');
        return false;
      }

      this.isSubmitting = true;
      this.$bus.$emit('loading');
      const data = {
        id: this.isCounted ? this.inventoryTag.id : 0,
        physical_count_list_id: this.physicalCountList.id,
        inventory_tag: this.inventoryTag.inventory_tag,
        inventory_item_id: this.inventoryTag.inventory_item_id,
        length_id: this.inventoryTag.length_id,
        uom_id: this.inventoryTag.uom_id,
        inventory_location_id: this.inventoryTag.inventory_location_id,
        color_id: this.inventoryTag.color_id,
        po_number: this.inventoryTag.po_number,
        counted_quantity: this.quantity,
        quantity: this.quantity,
        location_id: this.inventoryTag.location_id ? this.inventoryTag.location_id : 1,
        created_by: this.user.id,
        code: this.qrCode,
        door_hinge_id: this.inventoryTag.door_hinge_id,
        door_swing_id: this.inventoryTag.door_swing_id,
        door_lite_id: this.inventoryTag.door_lite_id,
        door_size_id: this.inventoryTag.door_size_id,
        ex_color_id: this.inventoryTag.ex_color_id,
        is_painted: this.inventoryTag.is_painted,
        height: this.inventoryTag.height,
        width: this.inventoryTag.width,
        is_fritted: this.inventoryTag.is_fritted,
        door_screen_id: this.inventoryTag.door_screen_id,
        dimension_unit_id: this.inventoryTag.dimension_unit_id,
        // glass: this.inventoryTag.glass,
      };

      if (this.inventoryTag.batch_number) {
        data.batch_number = this.inventoryTag.batch_number;
      }

      if (this.inventoryTag.production_date) {
        data.production_date = this.inventoryTag.production_date;
      }

      if (!this.isCounted) {
        data.original_quantity = this.inventoryTag.quantity_on_hand;
      }

      let response = null;
      try {
        response = await PhysicalCountApi.store(data);
      } catch {
        response = null;
      } finally {
        this.$bus.$emit('loading-stop');
      }

      if (!response) {
        this.isSubmitting = false;
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.isEdit = false;
      setTimeout(() => {
        this.$router.push('/physical-count-qr');
      }, 2000);
      // this.getInventoryTag();
    },

    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      return `data:${mimeType};base64, ${photo}`;
    },

    openItemShowImageForm(photo, type, code) {
      this.$refs.itemShowImageForm.openDialog(photo, type, code);
    },

    cancel() {
      if (this.isEdit) {
        this.isEdit = false;
        this.getInventoryTag();
      } else {
        this.redirectBack();
      }
    },

    receive() {
      //open RM Receiving QR Form
      if (parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999) {
      // Include records with qty on hand 0 for INSTALATION Class records
        this.$refs.upcForm.open(this.qrCode);
        return;
      } else if (parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999) {
        // this.$refs.mpqrForm.open(this.qrCode);
        this.$bus.$emit('showError', 'This form is not used for MPQRs, please contact support');
        return;
      }
      this.$bus.$emit('showError', 'Receiving is not allowed for regular QR Codes, please contact support');
      return;
    },

    move() {
      //open Move QR Form
      if((parseInt(this.qrCode, 10) > 199999 && parseInt(this.qrCode, 10) < 209999)) {
        this.$router.push(`/moving-qr/mpqr/${this.qrCode}`);
        return;
      }
      //if upc, show error message
      if (parseInt(this.qrCode, 10) > 99999 && parseInt(this.qrCode, 10) < 199999) {
        this.$bus.$emit('showError', 'UPC Codes cannot be relocated');
        return;
      }
      this.$router.push(`/moving-qr/${this.qrCode}`);
    },

    async receiveSuccess() {
      this.$bus.$emit('showSuccess', 'QR Code received successfully');
      this.$bus.$emit('loading');
      await this.getInventoryTag();
      this.$bus.$emit('loading-stop');
    },

    redirectBack() {
      this.$router.push('/physical-count-qr');
    },

    toggleEdit() {
      this.isEdit = !this.isEdit;
    },

    historyRedirect() {
      const transactionsTabIndex = 2;
      const transactionsTabId = 3;
      this.$store.commit('storeInventoryTab', transactionsTabIndex);
      this.$store.commit('storeInventoryTabId', transactionsTabId);
      this.$router.push({
        name: 'Inventory',
        params: {
          searchParam: `qr=${this.qrCode}`,
        },
      });
    },
    openNotes() {
      this.$refs.noteForm.open(this.qrCode);
    },

    isDecimalInFractions(decimalNumber) {
      return ValidationHelpers.isDecimalInFractions(decimalNumber);
    },
  },
};
</script>
<style scoped>
.inventory-identification-class {
  height: auto;
}

.inventory-identification-class >>> .v-chip__content {
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
}

.profile-photo-mini{
  max-width: 80px;

}
.profile-photo{

  max-height: 400px;
  max-width: 400px;

}
.v-text-field >>> input {
    font-size: 1.5em !important;
}

.v-autocomplete >>> input{
    font-size: 1.5em !important;
}

.v-btn {
    font-size: 1.1em !important;
}

::v-deep .v-input--radio-group--column .v-input--radio-group__input > .v-label {
    padding-bottom: 17px;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details
{
  margin-bottom: 0px;
}

::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px;
}

::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details[data-v-c940035e] {

}
</style>
